// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import CurrencyUtils from '../../utils/CurrencyUtils';

// -- views
import LocalizableSelect from './LocalizableSelect';

export default class CurrencyChooser extends Component {

  static defaultProps = {
    clearable: false
  };

  static propTypes = {
    // 'EUR' for example
    value: PropTypes.string.isRequired,

    // param: String (Country code 'FR' for example.)
    onChange: PropTypes.func.isRequired,

    clearable: PropTypes.bool
  };

  onChange = (option) => {
    if (_.isNull(option)) {
      this.props.onChange(null);
    } else {
      this.props.onChange(option.value);
    }
  };

  render() {
    const options = CurrencyUtils.getApiCurrencyOptions();

    return (
      <div className="country_chooser">
        <LocalizableSelect
          name="action"
          value={this.props.value}
          options={options}
          onChange={this.onChange}
          clearable={this.props.clearable}
        />
      </div>
    );
  }

}
